// $(document).ready(function(){
//   // ページ内スクロール
//   $('a[href^="#"]').click(function () {
//     const speed = 1;
//     let href = $(this).attr("href");
//     let target = $(href == "#" || href == "" ? "html" : href);
//     let adjust = 127; // Adjust this value to your needs
//     let position = target.offset().top - adjust;

//     // Check if the browser is Safari
//     var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

//     if (isSafari) {
//       $("body").animate({ scrollTop: position }, speed, "swing");
//     } else {
//       $("html, body").animate({ scrollTop: position }, speed, "swing");
//     }

//     return false;
//   });
// });

$(document).ready(function(){
  // Check if the browser is Safari
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  // If it's Safari, then use JavaScript for smooth scrolling
  if (isSafari) {
    // Page scroll
    $('a[href^="#"]').click(function () {
      const speed = 1;
      let href = $(this).attr("href");
      let target = $(href == "#" || href == "" ? "html" : href);
      let adjust = 127; // Adjust this value to your needs
      let position = target.offset().top - adjust;

      $("body").animate({ scrollTop: position }, speed, "swing");

      return false;
    });
  }
});
